import React from 'react';

import createStyle from 'shared-utils/src/createStyle';
import makeClassName from 'shared-utils/src/makeClassName';
import getExtPath from 'shared-utils/src/getExtPath';

import GridItem from '../../../GridItem';

import styles, { mainCls } from './style';

const useStyles = createStyle(styles);

export default function Placeholder({ size }) {
  const cls = useStyles();

  const galCls = makeClassName([
    cls[mainCls],
    size,
  ]);

  return (
    <GridItem
      className={galCls}
      behavior="fixed"
    >
      <div className={`${cls[`${mainCls}__wrap`]} c-bg--bg is-rel`}>
        <div className={`${cls[`${mainCls}__imgcont`]} tp-a--c`}>
          <img
            src={getExtPath('common_images/common/gallery_bg_tras.png')}      
            alt={'Casa.it'}
          />
        </div>
      </div>
    </GridItem>
  );
}